export default {"src":"/_next/static/media/header-socials-facebook.b9a6c325.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};